<div class="popover arrow-box" *ngIf="message">
    <div class="popitem">
        <span>
            {{ message }}
        </span>
    </div>
</div>
<div *ngIf="messages.length === 0">&nbsp;</div>
